import {
  createDropdownLov,
  deleteDropdownLov,
  dropdownLovFetcher,
  updateDropdownLov,
} from '../../../api/debugger-lov'
import {
  createLovServiceItem,
  deleteLovServiceItem,
  getLovKeyField,
  lovServiceFetcher,
  updateLovServiceItem,
} from '../../../api/lov-service'
import { CORE_FORM } from '../../../constants'
import { CrudInnerStorageFetcher, ProcedureInnerStorageFetcher } from '../../../types'
import { isLovServiceAvailable, isSBServiceAvailable } from '../../helpers/isCoreServiceAvailable'
import { IDropdownLOV } from '../../models/IDropdownLOV'

export const getLOVFetcher = () => {
  if (isLovServiceAvailable()) {
    return new ProcedureInnerStorageFetcher<IDropdownLOV>(getLovKeyField(), {
      readFromTo: lovServiceFetcher,
      updateHandler: updateLovServiceItem,
      createHandler: createLovServiceItem,
      deleteHandler: deleteLovServiceItem,
    })
  }

  if (isSBServiceAvailable()) {
    return new ProcedureInnerStorageFetcher<IDropdownLOV>('UID', {
      readFromTo: dropdownLovFetcher,
      updateHandler: updateDropdownLov,
      createHandler: createDropdownLov,
      deleteHandler: deleteDropdownLov,
    })
  }

  return new CrudInnerStorageFetcher<IDropdownLOV>('EntryId', {
    formId: CORE_FORM.dropdowns.id,
    code: CORE_FORM.dropdowns.code,
  })
}
